import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import { path } from 'ramda';
import Translate from 'react-translate-component';
import { TreeSelect } from 'antd';

import {
    METRO_REQUEST_ROUTES,
    METRO_REQUEST_MGL,
    METRO_REQUEST_HQ,
    METRO_REQUEST_STORE,
    METRO_REQUEST_ROUTES_FILTERS,
    METRO_REQUEST_NEW,
    METRO_REQUEST_CURRENT,
} from 'constants/metro';
import { SelectLoadComponent } from 'components/common/form/Select';
import ListenerField from 'components/common/form/ListenerField';
import {
    metroTown,
    metroDirectorats,
    metroUnits,
    metroDivision,
    metroRegion,
    metroStore,
} from 'constants/dictionaries';
import RadioButtons from 'components/common/form/RadioButtons';
import MetroDepartmentSelect from 'components/common/form/MetroDepartmentSelect';
import InputHidden from 'components/common/form/InputHidden';
import Input from 'components/common/form/Input';
import TranslateField from 'components/common/fields/TranslateField';

export default class MetroRequestBaseFields extends Component {
    renderDepartmentFields = (requestType, type, store, direction, unit, division) => {
        const noFilters = type === METRO_REQUEST_ROUTES_FILTERS[METRO_REQUEST_STORE]
            ? !store
            : type === METRO_REQUEST_ROUTES_FILTERS[METRO_REQUEST_HQ]
                ? !direction
                : false;
        const ru = path(['data', 'department'], this.props.getMetroRequest);
        const en = path(['data', 'departmentEngl'], this.props.getMetroRequest);

        return (
            <Fragment>
                <Field
                    name='departmentCode'
                    component={MetroDepartmentSelect}
                    label={{ content: 'metro.request.department', required: true }}
                    onChange={(...attrs) => {
                        this.props.getChangeField('department')(...attrs);
                        if (requestType === METRO_REQUEST_NEW) {
                            this.props.clearPosition(requestType);
                            this.props.form.change('requestType', null);
                        } else {
                            this.props.form.change('requestType', METRO_REQUEST_CURRENT);
                        }
                    }}
                    loadParams={{
                        type: type,
                        addCode: store,
                        URLEncfunction: direction,
                        URLEncunit: unit,
                        URLEncdivision: division,
                    }}
                    treeCheckable
                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                    disabled={noFilters || this.props.disabled}
                    valueString={(ru || en) ? (
                        <TranslateField ru={ru} en={en} />
                    ) : null}
                />
                <Field
                    name='function'
                    component={Input}
                    label={{ content: 'metro.request.functionCode' }}
                    disabled
                />
            </Fragment>
        );
    }

    render() {
        const { getChangeField, disabled } = this.props;

        return <Fragment>
            <Field
                name='routeType'
                component={RadioButtons}
                options={METRO_REQUEST_ROUTES}
                label={{ content: 'metro.request.requestRoute' }}
                onChange={this.props.clearBase}
                radioTranslate='metro.request.routes'
                disabled={disabled}
            />
            <Field
                name='positionCode'
                component={InputHidden}
                notWrap
            />
            <ListenerField listenFieldName={['routeType', 'requestType']}>
                { ({ routeType, requestType }) => {
                    switch(routeType) {
                        case METRO_REQUEST_MGL:
                            return (
                                <Fragment>
                                    <Field
                                        name='city'
                                        component={SelectLoadComponent}
                                        loadName={metroTown}
                                        label={{ content: 'metro.request.city', required: true }}
                                        valuePath='value'
                                        namePath='value'
                                        disabled={this.props.disabled}
                                    />
                                    { this.renderDepartmentFields(
                                        requestType,
                                        METRO_REQUEST_ROUTES_FILTERS[METRO_REQUEST_MGL]
                                    )}
                                </Fragment>
                            );
                        case METRO_REQUEST_STORE:
                            return (
                                <Fragment>
                                    <Field
                                        name='region'
                                        component={SelectLoadComponent}
                                        loadName={metroRegion}
                                        label={{ content: 'metro.request.region', required: true }}
                                        valuePath='value'
                                        namePath='value'
                                        onChange={() => {
                                            this.props.form.change('city', null);
                                            this.props.form.change('store', null);
                                            this.props.form.change('department', null);
                                            this.props.form.change('departmentCode', null);
                                            this.props.form.change('requestType', null);
                                            this.props.clearPosition(requestType);
                                        }}
                                        disabled={disabled}
                                    />
                                    <ListenerField listenFieldName='region'>
                                        {({ region }) => (
                                            <Field
                                                name='city'
                                                component={SelectLoadComponent}
                                                loadName={metroTown}
                                                loadParams={{ URLEncRegionStr: region }}
                                                label={{ content: 'metro.request.city', required: true }}
                                                valuePath='value'
                                                namePath='value'
                                                onChange={() => {
                                                    this.props.form.change('store', null);
                                                    this.props.form.change('department', null);
                                                    this.props.form.change('departmentCode', null);
                                                    this.props.form.change('requestType', null);
                                                    this.props.clearPosition(requestType);
                                                }}
                                                disabled={disabled}
                                            />
                                        )}
                                    </ListenerField>
                                    <ListenerField listenFieldName={['city', 'region']}>
                                        {({ city, region }) => (
                                            <Field
                                                name='storeCode'
                                                namePath='id'
                                                component={SelectLoadComponent}
                                                loadName={metroStore}
                                                loadParams={city ? { URLEncTownStr: city } : { URLEncRegionStr: region }}
                                                label={{ content: 'metro.request.store', required: true }}
                                                disabled={!city || disabled}
                                                onChange={(...attrs) => {
                                                    getChangeField('store')(...attrs);
                                                    this.props.form.change('department', null);
                                                    this.props.form.change('departmentCode', null);
                                                    this.props.form.change('requestType', null);
                                                    this.props.clearPosition(requestType);
                                                }}
                                            />
                                        )}
                                    </ListenerField>
                                    <ListenerField listenFieldName='storeCode'>
                                        {({ storeCode }) => (
                                            this.renderDepartmentFields(
                                                requestType,
                                                METRO_REQUEST_ROUTES_FILTERS[METRO_REQUEST_STORE],
                                                storeCode
                                            )
                                        )}
                                    </ListenerField>
                                </Fragment>
                            );
                        case METRO_REQUEST_HQ:
                            return (
                                <Fragment>
                                    <Field
                                        name='city'
                                        component={SelectLoadComponent}
                                        loadName={metroTown}
                                        label={{ content: 'metro.request.city', required: true }}
                                        valuePath='value'
                                        namePath='value'
                                        disabled={this.props.disabled}
                                    />
                                    <Field
                                        name='directorateEngl'
                                        valuePath='name'
                                        component={SelectLoadComponent}
                                        loadName={metroDirectorats}
                                        label={{ content: 'metro.request.directorateEngl', required: true }}
                                        onChange={() => {
                                            this.props.form.change('unitEngl', null);
                                            this.props.form.change('department', null);
                                            this.props.form.change('departmentCode', null);
                                            this.props.clearPosition(requestType);
                                        }}
                                        disabled={disabled}
                                    />
                                    <ListenerField listenFieldName='directorateEngl'>
                                        {({ directorateEngl }) => (
                                            <Field
                                                name='unitEngl'
                                                valuePath='name'
                                                component={SelectLoadComponent}
                                                loadName={metroUnits}
                                                loadParams={{ URLEncDirectorateStr: directorateEngl }}
                                                label={{ content: 'metro.request.unitEngl' }}
                                                onChange={() => {
                                                    this.props.form.change('divisionEngl', null);
                                                    this.props.form.change('department', null);
                                                    this.props.form.change('departmentCode', null);
                                                    this.props.clearPosition(requestType);
                                                }}
                                                disabled={disabled}
                                                allowClear
                                                placeholder={directorateEngl ? <Translate content='metro.request.noUnit' /> : null}
                                            />
                                        )}
                                    </ListenerField>
                                    <ListenerField listenFieldName={['unitEngl', 'directorateEngl']}>
                                        {({ unitEngl, directorateEngl }) => (
                                            <Field
                                                name='divisionEngl'
                                                valuePath='name'
                                                component={SelectLoadComponent}
                                                loadName={metroDivision}
                                                loadParams={{ URLEncUnitStr: unitEngl, URLEncDirectorateStr: directorateEngl }}
                                                label={{ content: 'metro.request.divisionEngl' }}
                                                placeholder={directorateEngl ? <Translate content='metro.request.noUnit' /> : null}
                                                onChange={() => {
                                                    this.props.form.change('department', null);
                                                    this.props.form.change('departmentCode', null);
                                                    this.props.clearPosition(requestType);
                                                }}
                                                disabled={disabled}
                                                allowClear
                                            />
                                        )}
                                    </ListenerField>
                                    <ListenerField listenFieldName={['directorateEngl', 'unitEngl', 'divisionEngl']}>
                                        {(values) => (
                                            this.renderDepartmentFields(
                                                requestType,
                                                METRO_REQUEST_ROUTES_FILTERS[METRO_REQUEST_HQ],
                                                undefined,
                                                values.directorateEngl,
                                                values.unitEngl,
                                                values.divisionEngl
                                            )
                                        )}
                                    </ListenerField>
                                </Fragment>
                            );
                        default:
                            return null;
                    }
                }}
            </ListenerField>
        </Fragment>;
    }
}
